import { render } from "./UnverifiedEmail.vue?vue&type=template&id=b803cb56"
import script from "./UnverifiedEmail.vue?vue&type=script&lang=js"
export * from "./UnverifiedEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__